import {REPORT_NEW_CLIENTS_WITHOUT_ORDERS} from '/enum/records.enum';

export default {
  reportName: REPORT_NEW_CLIENTS_WITHOUT_ORDERS,
};
